import React from "react";
import { useTranslation } from "react-i18next";

const TermsAndConditionsNorwayContent = () => {
  const { t } = useTranslation("common");
  return (
    <div className="row">
      <div className="col-xs-12">
        <div className="ukModalDetails">
          <p>{t("termsConditionModalNorway.paragraph1")}</p>
          <p>{t("termsConditionModalNorway.paragraph2")}</p>
          <p>{t("termsConditionModalNorway.paragraph3")}</p>
          <p>{t("termsConditionModalNorway.paragraph4")}</p>
          <p>{t("termsConditionModalNorway.paragraph5")}</p>
          <p>{t("termsConditionModalNorway.paragraph6")}</p>
          <p>{t("termsConditionModalNorway.paragraph7")}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsNorwayContent;
